import Joi from 'joi';
import api from '../../api';

/**
 * Get terminal by ID
 * @param {string} airportId - The airport ID.
 * @param {string} terminalId - The terminal ID.
 * @returns {Promise<Terminal|null>} - The terminal, or null if not found.
 */
export const getTerminal = async (airportId, terminalId) => {
  const result = await api.get(`/airports/${airportId}`);
  try {
    const terminals = result?.data?.terminals || [];
    const terminal = terminals.find((/** @type {Terminal} */ t) => String(t.id) === String(terminalId));
    return typeof terminal !== 'undefined' ? terminal : null;
  } catch (/** @type {any} */ error) {
    const errorObject = { error: `API response do not match get terminal Schema : ${error.message}` };
    throw errorObject;
  }
};

/**
 * Create terminal
 * @param {{airportId: string, terminal: Terminal}} params - The parameters object.
 * @returns {Promise<{id: string}>} - The created terminal ID.
 */
export const createTerminal = async ({ airportId, terminal }) => {
  const result = await api.post(`/airports/${airportId}/terminals`, terminal);
  try {
    const schema = Joi.object({
      id: Joi.number().required(),
    }).required();

    await schema.validateAsync(result.data, { allowUnknown: true });
    return result.data;
  } catch (/** @type {any} */ error) {
    const errorObject = { error: `API response do not match create terminal Schema : ${error.message}` };
    throw errorObject;
  }
};

/**
 * Update terminal
 * @param {{airportId: string, terminalId: string, terminal: Terminal}} params - The parameters object.
 * @returns {Promise<any>} - The updated terminal.
 */
export const updateTerminal = async ({ airportId, terminalId, terminal }) => {
  const result = await api.put(`/airports/${airportId}/terminals/${terminalId}`, terminal);
  try {
    return result.data;
  } catch (/** @type {any} */ error) {
    const errorObject = { error: `API response do not match update terminal Schema : ${error.message}` };
    throw errorObject;
  }
};

/**
 * Delete terminal
 * @param {string} airportId - The airport ID.
 * @param {string} terminalId - The terminal ID.
 * @returns {Promise<void>} - Resolves when terminal is deleted.
 */
export const deleteTerminal = async (airportId, terminalId) => {
  await api.delete(`/airports/${airportId}/terminals/${terminalId}`);
};
